export default __webpack_public_path__ + "static/pipes-0cf3702e00012bd7fdf3bd19ec8cf0bb.jpg";